/**
 * Quiz result capture & social share (html2canvas + platform handlers).
 * Loaded by sections/quiz-section.liquid — expects sectionId per instance.
 */
(function () {
    "use strict";

    window.quizLastResult = window.quizLastResult || {};
    window.quizShareBlob = window.quizShareBlob || {};
    window.quizSharePreviewUrl = window.quizSharePreviewUrl || {};

    function loadHtml2Canvas() {
        return new Promise(function (resolve, reject) {
            if (window.html2canvas) {
                resolve(window.html2canvas);
                return;
            }
            var script = document.createElement("script");
            script.src =
                "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
            script.onload = function () {
                resolve(window.html2canvas);
            };
            script.onerror = function () {
                reject(new Error("Gagal memuat library capture"));
            };
            document.head.appendChild(script);
        });
    }

    function waitForImages(element) {
        var images = element.querySelectorAll("img");
        return Promise.all(
            Array.prototype.map.call(images, function (img) {
                if (img.complete && img.naturalWidth > 0)
                    return Promise.resolve();
                return new Promise(function (resolve) {
                    img.onload = resolve;
                    img.onerror = resolve;
                });
            }),
        );
    }

    function getQuizShareText(sectionId) {
        var result = window.quizLastResult[sectionId];
        var title = result && result.title ? result.title : "hasil kuis Gently";
        return (
            'Saya dapat hasil "' +
            title +
            '" dari kuis temperamen anak di Gently! Coba juga yuk: ' +
            window.location.href
        );
    }

    function showQuizShareToast(sectionId, message) {
        var toast = document.getElementById("qz-share-toast-" + sectionId);
        if (!toast) return;
        toast.textContent = message;
        toast.classList.add("is-visible");
        setTimeout(function () {
            toast.classList.remove("is-visible");
        }, 2500);
    }

    function closeQuizShareModal(sectionId) {
        var modal = document.getElementById("qz-share-modal-" + sectionId);
        if (modal) modal.hidden = true;
        if (window.quizSharePreviewUrl[sectionId]) {
            URL.revokeObjectURL(window.quizSharePreviewUrl[sectionId]);
            window.quizSharePreviewUrl[sectionId] = null;
        }
    }

    function openQuizShareModal(sectionId, blob) {
        var modal = document.getElementById("qz-share-modal-" + sectionId);
        var preview = document.getElementById("qz-share-preview-" + sectionId);
        var nativeBtn = document.getElementById("qz-share-native-" + sectionId);
        if (!modal) return;

        window.quizShareBlob[sectionId] = blob;

        if (preview) {
            if (window.quizSharePreviewUrl[sectionId]) {
                URL.revokeObjectURL(window.quizSharePreviewUrl[sectionId]);
            }
            window.quizSharePreviewUrl[sectionId] = URL.createObjectURL(blob);
            preview.src = window.quizSharePreviewUrl[sectionId];
        }

        if (nativeBtn) {
            var file = new File([blob], "karakter-anak-gently.png", {
                type: "image/png",
            });
            var canShareFile =
                navigator.share &&
                navigator.canShare &&
                navigator.canShare({ files: [file] });
            nativeBtn.hidden = !navigator.share;
            nativeBtn.dataset.canShareFile = canShareFile ? "1" : "0";
        }

        modal.hidden = false;
    }

    function downloadQuizBlob(blob) {
        var url = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = "karakter-anak-gently.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    function captureQuizResult(sectionId) {
        var captureEl = document.getElementById(
            "qz-result-content-" + sectionId,
        );
        if (!captureEl)
            return Promise.reject(new Error("Elemen hasil tidak ditemukan"));

        var fontsReady =
            document.fonts && document.fonts.ready
                ? document.fonts.ready
                : Promise.resolve();
        var quizCopy =
            window.quizEngines &&
            window.quizEngines[sectionId] &&
            window.quizEngines[sectionId].quizData &&
            window.quizEngines[sectionId].quizData.copy
                ? window.quizEngines[sectionId].quizData.copy
                : {};
        var contentBgUrl =
            quizCopy.resultBg ||
            "https://cdn.shopify.com/s/files/1/0717/8197/4178/files/bg-card-gently.png?v=1780893880";

        return Promise.all([waitForImages(captureEl), fontsReady])
            .then(loadHtml2Canvas)
            .then(function (html2canvas) {
                var rect = captureEl.getBoundingClientRect();
                return html2canvas(captureEl, {
                    useCORS: true,
                    scale: 3,
                    backgroundColor: null,
                    width: rect.width,
                    height: rect.height,
                    logging: false,
                    onclone: function (_clonedDoc, clonedElement) {
                        clonedElement.classList.add("is-capturing");
                        clonedElement.style.position = "relative";
                        clonedElement.style.width = rect.width + "px";
                        clonedElement.style.height = rect.height + "px";
                        clonedElement.style.fontFamily = "'Nunito', sans-serif";
                        clonedElement.style.backgroundImage =
                            'url("' + contentBgUrl + '")';
                        clonedElement.style.backgroundSize = "cover";
                        clonedElement.style.backgroundPosition = "center";
                        clonedElement.style.backgroundRepeat = "no-repeat";
                    },
                });
            })
            .then(function (canvas) {
                return new Promise(function (resolve, reject) {
                    canvas.toBlob(function (blob) {
                        if (!blob) reject(new Error("Gagal membuat gambar"));
                        else resolve(blob);
                    }, "image/png");
                });
            });
    }

    function getQuizShareFile(blob) {
        return new File([blob], "karakter-anak-gently.png", {
            type: "image/png",
        });
    }

    function canShareQuizImage(blob) {
        if (!blob || !navigator.share || !navigator.canShare) return false;
        return navigator.canShare({ files: [getQuizShareFile(blob)] });
    }

    function shareQuizImageNative(blob, shareText) {
        return navigator.share({
            files: [getQuizShareFile(blob)],
            title: "Hasil Kuis Gently",
            text: shareText,
        });
    }

    function copyQuizImageToClipboard(blob) {
        if (!blob || !navigator.clipboard || !window.ClipboardItem)
            return Promise.resolve(false);
        return navigator.clipboard
            .write([new ClipboardItem({ "image/png": blob })])
            .then(function () {
                return true;
            })
            .catch(function () {
                return false;
            });
    }

    function shareQuizWithImage(blob, shareText, fallback) {
        if (blob && canShareQuizImage(blob)) {
            return shareQuizImageNative(blob, shareText).catch(function () {
                if (fallback) fallback();
            });
        }
        if (fallback) fallback();
    }

    function handleQuizShareOption(sectionId, platform) {
        var shareText = getQuizShareText(sectionId);
        var blob = window.quizShareBlob[sectionId];
        var shareUrl;

        switch (platform) {
            case "whatsapp":
                shareQuizWithImage(blob, shareText, function () {
                    window.open(
                        "https://wa.me/?text=" + encodeURIComponent(shareText),
                        "_blank",
                        "noopener,noreferrer",
                    );
                });
                break;
            case "facebook":
                shareQuizWithImage(blob, shareText, function () {
                    copyQuizImageToClipboard(blob).then(function (copied) {
                        window.open(
                            "https://www.facebook.com/",
                            "_blank",
                            "noopener,noreferrer",
                        );
                        showQuizShareToast(
                            sectionId,
                            copied
                                ? "Gambar disalin! Buat postingan lalu tempel (Ctrl+V / Cmd+V)"
                                : "Gambar sudah diunduh. Unggah dari folder Downloads saat buat postingan",
                        );
                    });
                });
                break;
            case "instagram":
                copyQuizImageToClipboard(blob).then(function (copied) {
                    window.open(
                        "https://www.instagram.com/",
                        "_blank",
                        "noopener,noreferrer",
                    );
                    showQuizShareToast(
                        sectionId,
                        copied
                            ? "Gambar disalin! Buat postingan Instagram lalu tempel atau unggah dari galeri"
                            : "Gambar sudah diunduh. Unggah dari galeri saat buat postingan Instagram",
                    );
                });
                break;
            case "x":
                shareUrl =
                    "https://x.com/intent/tweet?text=" +
                    encodeURIComponent(shareText);
                window.open(
                    shareUrl,
                    "_blank",
                    "noopener,noreferrer,width=600,height=500",
                );
                break;
            case "email":
                window.location.href =
                    "mailto:?subject=" +
                    encodeURIComponent("Hasil Kuis Gently") +
                    "&body=" +
                    encodeURIComponent(shareText);
                break;
            case "copy":
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(shareText).then(function () {
                        showQuizShareToast(sectionId, "Teks berhasil disalin");
                    });
                }
                break;
        }
    }

    window.closeQuizShareModal = closeQuizShareModal;

    window.shareResult = function (sectionId) {
        var btn = document.getElementById("qz-share-btn-" + sectionId);
        if (!btn) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = "Membuat gambar...";

        captureQuizResult(sectionId)
            .then(function (blob) {
                downloadQuizBlob(blob);
                openQuizShareModal(sectionId, blob);
            })
            .catch(function (err) {
                console.error(err);
                alert("Gagal membuat gambar. Silakan coba lagi.");
            })
            .finally(function () {
                btn.disabled = false;
                btn.textContent = originalText;
            });
    };

    window.initQuizShare = function (sectionId) {
        var modal = document.getElementById("qz-share-modal-" + sectionId);
        if (!modal || modal.dataset.qzShareBound === "1") return;
        modal.dataset.qzShareBound = "1";

        var closeBtn = modal.querySelector(".qz-share-modal-close");
        var overlay = modal.querySelector(".qz-share-modal-overlay");

        function handleCloseClick(e) {
            e.preventDefault();
            e.stopPropagation();
            closeQuizShareModal(sectionId);
        }

        if (closeBtn) {
            closeBtn.addEventListener("click", handleCloseClick);
        }

        if (overlay) {
            overlay.addEventListener("click", handleCloseClick);
        }

        modal.addEventListener("click", function (e) {
            var shareBtn = e.target.closest("[data-qz-share]");
            if (shareBtn) {
                handleQuizShareOption(
                    sectionId,
                    shareBtn.getAttribute("data-qz-share"),
                );
            }
        });

        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape" && !modal.hidden) {
                closeQuizShareModal(sectionId);
            }
        });
    };
})();
